import { render } from "./Rota.vue?vue&type=template&id=da51dc8c"
import script from "./Rota.vue?vue&type=script&lang=js"
export * from "./Rota.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__